// MUI
import { Grid, Skeleton, Stack } from "@mui/material";

type TableLoaderProps = {
	sx?: object;
	bigTitle?: boolean;
	widthBigTitle?: number;
	smallTitle?: boolean;
	widthSmallTitle?: number;
	toolbar?: boolean;
	toolbarSx?: object;
	buttons?: number;
	multiTitles?: number;
	multiTitlesSpaces?: string;
	content?: boolean;
	rows?: number;
	className?: string;
	toolbarClasses?: string;
};
export default function TableLoader(props: Readonly<TableLoaderProps>) {
	return (
		<>
			<Grid container className={props.className} width={"100%"} justifyContent={"space-between"} alignItems={"center"} sx={props.sx}>
				<Grid item>
					{props.bigTitle && (
						<Skeleton variant="text" width={props.widthBigTitle ?? 300} height={36} sx={{ borderRadius: "6px" }} />
					)}
					{props.smallTitle && (
						<Skeleton variant="text" width={props.widthSmallTitle ?? 300} height={28} sx={{ borderRadius: "6px" }} />
					)}
				</Grid>

				{props.toolbar && (
					<Grid
						className={props.toolbarClasses}
						item
						sx={{
							...props.toolbarSx,
							display: "flex",
							justifyContent: "flex-end",
						}}
					>
						<Stack sx={{ justifyContent: "flex-end" }} direction={"row"} spacing={1}>
							{Array.from(Array(props.buttons)).map((_, key) => (
								<Skeleton key={key} variant="circular" width={35} height={35} />
							))}
						</Stack>
					</Grid>
				)}

				{props.multiTitles && (
					<Grid mb={-1} container direction="row" alignItems="left">
						{Array.from(Array(props.multiTitles)).map((_, key) => (
							<Skeleton
								className={`rounded-md ${key !== 0 ? "ml-" + props.multiTitlesSpaces : ""} ${key === 0 ? "ml-0" : "ml-10"}`}
								variant="rectangular"
								width={120}
								height={20}
								key={key}
							/>
						))}
					</Grid>
				)}
			</Grid>

			{props.content && (
				<Grid container mt={2} rowSpacing={1}>
					{Array.from(Array(props.rows)).map((_, key) => (
						<Grid item key={key} xs={12}>
							<Skeleton variant="rectangular" className="w-full h-5 rounded-md" />
						</Grid>
					))}
				</Grid>
			)}
		</>
	);
}
